var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArab = function SvgArab(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12c0 4.367 2.8 8.067 6.667 9.433V2.567C4.8 3.933 2 7.633 2 12Z",
    fill: "#ED4C5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2c-1.167 0-2.3.2-3.333.567v6.1h12.766C20.067 4.8 16.367 2 12 2Z",
    fill: "#699635"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.433 8.667H8.667v6.666h12.766A9.997 9.997 0 0 0 22 12c0-1.167-.2-2.3-.567-3.333Z",
    fill: "#F9F9F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.667 15.333v6.1A10 10 0 0 0 12 22a9.967 9.967 0 0 0 9.433-6.667H8.667Z",
    fill: "#3E4347"
  })));
};
export default SvgArab;